import React from "react";

interface ResultSummaryProps {
  result: any;
}

export const ResultSummary: React.FC<ResultSummaryProps> = ({ result }) => {
  if (!result) return null;

  return (
    <div className="bg-[#2a2a2a] rounded-2xl shadow-lg p-4 md:p-6">
      <h2 className="text-base md:text-lg font-bold text-neutral-100 mb-4 md:mb-6">Calculation Summary</h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
        <div className="space-y-1">
          <p className="text-sm md:text-base font-semibold text-neutral-300">Recommended Lot Size:</p>
          <p className="text-sm md:text-base text-yellow-400">{result.recommendedLotSize || "-"} lots</p>
        </div>

        <div className="space-y-1">
          <p className="text-sm md:text-base font-semibold text-neutral-300">Risk Per Trade:</p>
          <p className="text-sm md:text-base text-yellow-400">${result.riskPerTrade || "-"}</p>
        </div>

        <div className="space-y-1">
          <p className="text-sm md:text-base font-semibold text-neutral-300">Estimated Margin Needed:</p>
          <p className="text-sm md:text-base text-yellow-400">${result.marginRequired || "-"}</p>
        </div>

        <div className="space-y-1">
          <p className="text-sm md:text-base font-semibold text-neutral-300">Total Daily Risk Planned:</p>
          <p className={`text-sm md:text-base ${parseFloat(result.dailyRiskPercent) > 2 ? "text-red-400" : "text-green-400"}`}>
            {result.dailyRiskPercent}%
          </p>
        </div>

        <div className="space-y-1">
          <p className="text-sm md:text-base font-semibold text-neutral-300">Max Drawdown Status:</p>
          <p className={`text-sm md:text-base ${parseFloat(result.currentDrawdownPercent) > result.maxDrawdownPercent ? "text-red-400" : "text-green-400"}`}>
            {result.currentDrawdownPercent}% used
          </p>
        </div>

        <div className="space-y-1">
          <p className="text-sm md:text-base font-semibold text-neutral-300">Potential Profit:</p>
          <p className="text-sm md:text-base text-yellow-400">${typeof result.potentialProfit === 'number' ? result.potentialProfit.toFixed(2) : (result.potentialProfit || "-")}</p>
        </div>

        <div className="space-y-1">
          <p className="text-sm md:text-base font-semibold text-neutral-300">Risk-to-Reward Ratio:</p>
          <p className="text-sm md:text-base text-yellow-400">{typeof result.riskToRewardRatio === 'number' ? result.riskToRewardRatio.toFixed(2) : (result.riskToRewardRatio || "-")}</p>
        </div>
      </div>

      {result.marginWarning && (
        <div className="bg-red-100 text-red-700 p-3 md:p-4 rounded-lg mt-4 md:mt-6 text-sm md:text-base">
          <p><strong>⚠️ Margin Warning:</strong> Your planned lot size may exceed available margin!</p>
        </div>
      )}

      {result.drawdownWarning && (
        <div className="bg-red-100 text-red-700 p-3 md:p-4 rounded-lg mt-4 md:mt-6 text-sm md:text-base">
          <p><strong>⚠️ Drawdown Warning:</strong> You're close to breaching your max allowable drawdown!</p>
        </div>
      )}
    </div>
  );
};

export default ResultSummary;
